import React from 'react';
import { Redirect } from 'react-router-dom';

const QueryRedirect = ({ location, to, keepQuery, ...rest }) => (
  <Redirect
    {...rest}
    to={
      keepQuery
        ? {
            ...location,
            pathname: to,
          }
        : to
    }
  />
);
export default QueryRedirect;
